export enum mimeTypes {
    'application/pdf',
    'image/png',
    'image/jpeg',
}